﻿const defaultState = {
    formSubmitFailed: false
}

export function coInsuredFormData(state = defaultState, action) {
    switch (action.type) {
        case 'COINSURED_FORM_SUBMITTED':
            return { ...state, ...action.data };
        case 'COINSURED_FORM_SUBMIT_FAILED':
            return { ...state, formSubmitFailed: !!action.data };
        case 'GET_CUSTOMER_INFO':
            return { ...state, ...action.payload };
            break;
        default:
            return state;
    }
}